import { styled } from "@material-ui/core";

export const HelpIcon = ({ className, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      style={{
        fill: "#808080",
        opacity: 0.5,
      }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1080 1080"
      className={className}
    >
      <rect className="a" x="506.75" y="714.55" width="67.86" height="67.86" />
      <path
        className="a"
        d="M677.898,441.218A110.7615,110.7615,0,0,1,645.527,519.53l-31.3248,32.012c-25.0578,25.4066-40.72,46.29-40.72,98.4979H503.8781V632.6441a140.089,140.089,0,0,1,40.72-98.4978L587.76,490.2875a68.0573,68.0573,0,0,0,20.5344-49.07,69.609,69.609,0,0,0-139.218,0H399.462a139.218,139.218,0,0,1,278.436,0Z"
      />
      <path
        className="a"
        d="M540.5583,122.7021c-230.9885,0-418.4519,187.4635-418.4519,418.4418S309.57,959.5957,540.5583,959.5957C771.5365,959.5957,959,772.1221,959,541.1439S771.5365,122.7021,540.5583,122.7021Zm0,753.1971c-184.5367,0-334.7554-150.2187-334.7554-334.7553S356.0216,206.3884,540.5583,206.3884,875.3137,356.6071,875.3137,541.1439,725.095,875.8992,540.5583,875.8992Z"
      />
    </svg>
  );
};

export const TooltipHeader = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: theme.typography.body2.fontSize,
  lineHeight: theme.typography.body2.lineHeight,
  fontWeight: theme.typography.fontWeightBold,
}));

export const TooltipContent = styled("div")(({ theme }) => ({
  lineHeight: theme.typography.body2.lineHeight,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
}));



// WEBPACK FOOTER //
// ./resources/assets/js/app/InfoTooltip/TooltipModules.js